import * as React from 'react';
import Service from '../../util/Service';
import { time_cache } from '../login/Login';

function useProfile(forceUpdate) {
    // const {forceUpdate} = props;
    const [isOk, setIsOk] = React.useState(false);
    const [profile, setProfile] = React.useState();
    const [rules, setRules] = React.useState();

    const wasCalled = React.useRef(false);

    React.useEffect(() => {
        if (!localStorage.accessToken) return;
        if (wasCalled.current) return;
        if( forceUpdate === true){
            callNormal();
        }else if (!profile) {
            const txt_prof = sessionStorage.getItem("profile");
            if (txt_prof) {
                const profile = JSON.parse(txt_prof);
                //const diff = (new Date().getTime()) - profile.timeout
                const diff = profile.timeout - (new Date().getTime()) ;
                // console.log(">>window.location<<", window.location.pathname)
                // console.log('time   : '+ new Date().getTime())
                // console.log('timeout: '+ profile.timeout)
                // console.log('diff: ' + diff);
                if (diff >= 0) {
                    // if (profile && profile.timeout && profile.timeout > (new Date().getTime())) {
                    // if (profile ) {                    
                    setProfile(profile);
                    setIsOk(true);
                    setRules(profile.rules);
                    if( profile.changePass){
                        if( window.location.pathname !== '/users/myAccount')
                        window.location.replace("/users/myAccount");
                    }
                } else {
                    callNormal();
                }
            } else {
                callNormal();
            }
        } 
    }, [profile]);

    function callNormal() {
        // console.log('>>>>callNormal<<<<<');
        wasCalled.current = true;
        if (!isOk) {
            // console.log('>>call server<<')
            const call = Service.GET("/api/security/profile");
            if( call ){
                call.then(ret => {
                    setProfile(ret);
                    setIsOk(true);
                    setRules(ret.rules);
                    ret.timeout = time_cache + (new Date().getTime());
                    sessionStorage.setItem("profile", JSON.stringify(ret));
                    if( ret.changePass){
                        window.location.replace("/users/myAccount");
                    }
                }).catch((e) => {
                    setIsOk(false);
                    console.error(e);
                    if (e.indexOf('Acesso não permitido') >= 0 && localStorage.accessToken) {
                        //localStorage.setItem("page", window.location.pathname);
                        //setTimeout(function () { window.location.replace("/login"); }, 1000);
                    }
                });
            }else{
                setIsOk(false);
            }
        }
    }

    const temAcesso = (rule) => {
        return rules && rules.includes(rule);
    }
    const profileProps = {
        profile: profile,
        isOk: isOk,
        temAcesso: temAcesso
    }
    // return [profile, isOk, temAcesso];
    return profileProps;
}


export { useProfile };